<template>
  <div class="news">
    <div class="news-imgs">
      <img :src="bgtop" class="video-img" loading="lazy">
      <div class="img-content">
        <h3>峰学资讯</h3>
        <p>聚焦全国高考资讯，助您轻松完成升学规划</p>
      </div>
    </div>
    <div class="news-content">
      <div class="news-content-top">
        <ul class="tab-title">
          <li :class="activeName === 'recent' ? 'active' : ''" @click="handleClick('recent')">最新资讯</li>
          <li :class="activeName === 'popular' ? 'active' : ''" @click="handleClick('popular')">热门资讯</li>
        </ul>
        <div class="search-filter">
          <el-input placeholder="请输入搜索内容" style="width: 485px;" class="filter-item" v-model="searchContent" clearable />
          <el-button icon="el-icon-search" type="primary" @click="handleFilter">搜索</el-button>
        </div>
      </div>
      <div class="main-content" v-loading.fullscreen.lock="fullscreenLoading" ref="wrapper">
        <div class="list-content" v-if="activeName === 'recent'">
          <el-row :gutter="24">
            <el-col :span="8" :offset="3" v-for="(item, index) in newsList" :key="item.uuid"
              :class="index % 3 === 2 ? 'lastCol' : ''">
              <el-card shadow="never">
                <router-link :to="{ name: 'newsdetails', params: { id: item.uuid } }">
                  <div class="img-content">
                    <div class="image-img" v-show="item.type === 1">
                      <img :src="item.cover_url" class="image" />
                    </div>
                    <div class="video-img" v-show="item.type === 2" @mouseenter="changeActiveed($event)"
                      @mouseleave="removeActiveed($event)">
                      <div class="shadow-img"></div>
                      <img :src="item.cover_url" class="video" />
                      <img :src="videoCard" class="videoCard" v-show="item.type === 2" />
                      <img :src="playVideo" class="playVideo" v-show="item.type === 2" />
                    </div>

                  </div>
                  <div class="summary-content">
                    <h3 class="title">{{ item.title }}</h3>
                    <p class="content">{{ item.summary }}</p>
                    <!--<p class="content" v-html="item.content" v-if="item.type === 1"></p>
                  <p class="content" v-else>{{item.summary}}</p>-->
                    <div class="bottom-content">
                      <span>{{ item.teacher_info ? item.teacher_info.name : item.author }} | {{ item.add_time ?
                        item.add_time.split(' ')[0] : '' }}</span>
                      <span style="margin-left: 5px;"></span>
                      <span style="margin-left: auto;"
                        v-if="item.actual_watching_amount >= 0 && item.actual_watching_amount <= 9999">{{
                          item.actual_watching_amount }}人浏览</span>
                      <span style="margin-left: auto;"
                        v-else-if="item.actual_watching_amount >= 10000 && item.actual_watching_amount <= 99999">{{
                          (item.actual_watching_amount / 10000).toFixed(1) }}万人浏览</span>
                      <span style="margin-left: auto;" v-else-if="item.actual_watching_amount === 100000">10万人浏览</span>
                      <span style="margin-left: auto;" v-else>10+万人浏览</span>
                    </div>
                  </div>
                </router-link>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div class="list-content" ref="list" v-else>
          <el-row :gutter="24">
            <el-col :span="8" :offset="3" v-for="(item, index) in newsList" :key="item.uuid"
              :class="index % 3 === 2 ? 'lastCol' : ''">
              <el-card shadow="never">
                <router-link :to="{ name: 'newsdetails', params: { id: item.uuid } }">
                  <div class="img-content">
                    <div class="image-img" v-show="item.type === 1">
                      <img :src="item.cover_url" class="image" />
                    </div>
                    <div class="video-img" v-show="item.type === 2" @mouseenter="changeActiveed($event)"
                      @mouseleave="removeActiveed($event)">
                      <div class="shadow-img"></div>
                      <img :src="item.cover_url" class="video" />
                      <img :src="videoCard" class="videoCard" v-show="item.type === 2" />
                      <img :src="playVideo" class="playVideo" v-show="item.type === 2" />
                    </div>

                  </div>
                  <div class="summary-content">
                    <h3 class="title">{{ item.title }}</h3>
                    <p class="content">{{ item.summary }}</p>
                    <!--<p class="content" v-html="item.content" v-if="item.type === 1"></p>
                    <p class="content" v-else>{{item.summary}}</p>-->
                    <div class="bottom-content">
                      <span>{{ item.teacher_info ? item.teacher_info.name : item.author }} | {{ item.add_time ?
                        item.add_time.split(' ')[0] : '' }}</span>
                      <span style="margin-left: 5px;"></span>
                      <span style="margin-left: auto;"
                        v-if="item.actual_watching_amount >= 0 && item.actual_watching_amount <= 9999">{{
                          item.actual_watching_amount }}人浏览</span>
                      <span style="margin-left: auto;"
                        v-else-if="item.actual_watching_amount >= 10000 && item.actual_watching_amount <= 99999">{{
                          (item.actual_watching_amount / 10000).toFixed(1) }}万人浏览</span>
                      <span style="margin-left: auto;" v-else-if="item.actual_watching_amount === 100000">10万人浏览</span>
                      <span style="margin-left: auto;" v-else>10+万人浏览</span>
                    </div>
                  </div>
                </router-link>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div class="no-content" v-if="noContent">
          <img :src="noContentImg">
          <p>抱歉，未搜索到相关资讯</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bgtop from "@/assets/img/bg.jpg";
import noContentImg from '@/assets/img/no-content.png';
import videoCard from "@/assets/img/video-card.png";
import playVideo from "@/assets/img/playIcon.png";
import BScroll from 'better-scroll';
export default {
  name: "news",
  /*components: {
    Banner
  },*/
  data() {
    return {
      fullscreenLoading: false,
      newsList: [],
      newstype: 1,
      activeName: 'recent',
      bgtop: bgtop,
      searchContent: '',
      noContent: false,
      noContentImg: noContentImg,
      videoCard: videoCard,
      playVideo: playVideo,
      loadDisabled: false,
      page: 0,
      size: 12,
      totalPages: 100,
      current_page: 1,
      noMoreData: false,
    };
  },
  mounted() {
    this.loadData();
    this.$nextTick(() => {
      new BScroll(this.$refs.wrapper); // 初始化better-scroll对象

      window.addEventListener('scroll', this.handleScroll); // 添加滚动事件监听器
    });
  },
  methods: {
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const scrollBottom = scrollHeight - scrollTop - clientHeight;

      if (!this.fullscreenLoading && !this.noMoreData && scrollBottom < 10) {
        this.loadData(); // 滚动到底部时调用加载更多函数
      }
    },
    loadData() {
      if (this.page >= this.totalPages) {
        this.noMoreData = true; // 已经加载完所有数据
        return;
      }
      this.fullscreenLoading = true;
      setTimeout(() => {
        this.page++;
        this.$http({
          method: 'get',
          url: '/api/v1/main_station/main/news/',
          params: {
            mold: this.newstype,
            title: this.searchContent,
            page: this.page,
            size: this.size
          },
          headers: {
            'AUTH-SYS': 'admin'
          },
        }).then(res => {
          this.fullscreenLoading = false;
          window.console.log(res)
          if (res.data.code === 20000) {
            this.totalPages = res.data.data.total_page;
            this.current_page = res.data.data.current_page;
            this.newsList = this.newsList.concat(res.data.data.results);
            if (this.newsList.length > 0) {
              this.noContent = false;
            } else {
              this.noContent = true;
            }
            if (this.page === this.totalPages) {
              this.noMoreData = true;
            } else {
              this.noMoreData = false;
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      }, 1000)

    },
    //搜索
    handleFilter() {
      this.page = 0;
      this.newsList = [];
      this.loadData();
    },
    handleClick(type) {
      this.activeName = type;
      this.searchContent = '';
      if (type === 'recent') {
        this.newstype = 1
      } else {
        this.newstype = 2
      }
      this.page = 0;
      this.newsList = [];
      this.loadData();
    },
    changeActiveed(e) {
      e.currentTarget.className = 'video_active';
    },
    removeActiveed(e) {
      e.currentTarget.className = 'video-img';
    }
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
}

@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.fxwljy.com/attach/file1706509868982.otf');
}

@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.fxwljy.com/attach/file1706509868791.otf');
}

.news {
  width: 100%;
  height: 100%;
  background-color: #F5F7FA;
  position: relative;
  overflow: hidden;

  .news-imgs {
    width: 100%;
    /*height: 480px;*/
    position: relative;
    overflow: hidden;

    img {
      width: 100%;
      /*height: 480px;*/
      object-fit: contain;
    }

    .img-content {
      position: absolute;
      left: 40%;
      top: 40%;
      transition: -40% -40%;
      text-align: center;

      h3 {
        font-size: 40px;
        font-family: 'SourceHanSansCNBold Microsoft YaHei';
        font-weight: bold;
        color: #FFFFFF;
        line-height: 60px;
      }

      p {
        font-size: 18px;
        font-family: 'SourceHanSansCN Microsoft YaHei';
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
        line-height: 24px;
        margin-top: 30px;
      }
    }
  }

  .news-content {
    width: 100%;
    /*height: 85px;*/
    background: #FFFFFF;
    margin-bottom: 20px;
    margin-top: -2px;

    .news-content-top {
      width: 1200px;
      margin: 0 auto;
      height: 86px;
      line-height: 86px;

      .tab-title {
        display: flex;
        float: left;

        li {
          list-style: none;
          margin: 0 20px;
          font-size: 18px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #0A0D0F;
          cursor: pointer;
        }

        .active {
          font-weight: bold;
          color: #0A0D0F;
          border-bottom: 3px solid #0086FF;
          font-family: 'SourceHanSansCNBold Microsoft YaHei';
        }
      }

      .search-filter {
        float: right;
        display: flex;

        .el-input {
          margin-right: 10px;
        }

        ::v-deep .el-input__inner {
          border: none !important;
          background: #F5F7FA !important;
          border-radius: 4px !important;
          color: #0A0D0F;
        }

        .el-button {
          font-size: 14px;
          font-family: 'SourceHanSansCNBold Microsoft YaHei';
          font-weight: bold;
          color: #FFFFFF;
          line-height: 21px;
          width: 100px;
          height: 40px;
          background: #0086FF;
          margin-top: 23px;
          border: 0px;

          ::v-deep .el-icon-search {
            margin-right: 5px;
            font-weight: bold;
          }
        }
      }
    }

    .main-content {
      background: #F5F7FA;
      width: 100%;
      height: 850px;

      /*min-height: 800px;*/
      /*height: 500px;
      overflow-y: auto;*/
      .list-content {
        width: 1200px;
        margin: 0px auto;
        padding-top: 36px;
        transform: translateX(0px) translateY(0px) translateZ(1px) !important;

        ::v-deep .el-row {
          margin-left: 0 !important;
          margin-right: 0 !important;
        }

        .lastCol {
          margin-right: 0 !important;
        }

        ::v-deep .el-col-8 {
          padding-left: 0 !important;
          padding-right: 0 !important;
        }

        .el-col-8 {
          width: 380px;
          height: 502px;
          margin-bottom: 30px;
          text-decoration: none;
          margin-right: 30px;

          .el-card {
            cursor: pointer;
            border-radius: 16px;
            border: none !important;
            height: 100%;
          }

          .title {
            font-size: 20px;
            font-family: 'SourceHanSansCNBold Microsoft YaHei';
            font-weight: bold;
            color: #0A0D0F;
            line-height: 30px;
            max-height: 56px;
            display: -webkit-box;
            /* 必须设置display为-webkit-box */
            overflow: hidden;
            /* 隐藏超出容器范围的内容 */
            text-overflow: ellipsis;
            /* 当内容被修剪时显示省略号 */
            -webkit-line-clamp: 2;
            /* 只显示前三行 */
            -webkit-box-orient: vertical;
            /* 垂直布局 */
            /*letter-spacing: 1px;*/
          }

          .img-content {
            position: relative;
          }

          .summary-content {
            padding: 20px;
            height: 207px;
            position: relative;
          }

          .content {
            font-size: 16px;
            font-family: 'SourceHanSansCN Microsoft YaHei';
            font-weight: 400;
            color: #434649;
            line-height: 30px;
            letter-spacing: 1px;
            margin-top: 16px;
            display: -webkit-box;
            /* 必须设置display为-webkit-box */
            overflow: hidden;
            /* 隐藏超出容器范围的内容 */
            text-overflow: ellipsis;
            /* 当内容被修剪时显示省略号 */
            -webkit-line-clamp: 3;
            /* 只显示前三行 */
            -webkit-box-orient: vertical;
            /* 垂直布局 */
            max-height: 86px;
            min-height: 86px;
            /*height: 76px;
            min-height: 76px;*/
            text-align: justify;
          }

          .bottom-content {
            display: flex;
            width: 90%;
            /*margin-top: 20px;*/
            position: absolute;
            bottom: 30px;

            span {
              font-size: 14px;
              font-family: 'SourceHanSansCN Microsoft YaHei';
              font-weight: 400;
              color: #909295;
              line-height: 21px;
            }
          }

          ::v-deep .el-card__body {
            padding: 6px !important;
          }
        }

        .image-img {
          width: 368px;
          height: 225px;
          /*transition: all .25s ease;*/
          overflow: hidden;
          border-radius: 12px;
        }

        .image {
          width: 100%;
          display: block;
          height: 225px;
          border-radius: 12px;
          transition: all .8s;
        }

        .image:hover {
          transform: scale(1.05);
        }

        .video-img {
          position: relative;

          .shadow-img {
            width: 368px;
            height: 225px;
            transition: all .25s ease;
            overflow: hidden;
            border-radius: 12px;
            background: rgba(0, 0, 0, 0.5);
            z-index: 100;
            position: absolute;
            display: none;
          }

          .playVideo {
            position: absolute;
            top: 45%;
            left: 45%;
            transition: -45% -45%;
            height: 40px;
            width: 40px;
            z-index: 1000;
            display: none;
          }
        }

        .video_active {
          .shadow-img {
            width: 368px;
            height: 225px;
            transition: all .25s ease;
            overflow: hidden;
            border-radius: 12px;
            background: rgba(0, 0, 0, 0.5);
            z-index: 100;
            position: absolute;
          }

          .playVideo {
            position: absolute;
            top: 45%;
            left: 45%;
            transition: -45% -45%;
            height: 40px;
            width: 40px;
            z-index: 1000;
          }
        }

        .video {
          width: 100%;
          display: block;
          height: 225px;
          border-radius: 12px;
        }

        .videoCard {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 64px;
          height: 28px;
          z-index: 1000;
        }

      }

      .no-content {
        width: 1200px;
        margin: 0px auto;
        padding-top: 36px;
        text-align: center;
        margin-bottom: 200px;

        img {
          width: 160px;
          height: 160px;
        }

        p {
          font-size: 14px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #909295;
          line-height: 21px;
        }
      }
    }
  }
}
</style>